import React from 'react';
import Watchlist from './list';

const WatchGroup = (props) => {
    return (
        <div>
            <Watchlist {...props}></Watchlist >
        </div>
    );
};

export default WatchGroup;